import {
    DELETE_REPORT_REQUEST,
    deleteReportSuccess,
    deleteReportFailure,
    showNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

export const deleteReportEpic = (action$, store$, { ReportRepository }) => {
    return action$.pipe(
        ofType(DELETE_REPORT_REQUEST),
        mergeMap(action => from(ReportRepository.remove( action.payload.id ))
            .pipe(
                mergeMap(() => {
                    return from([
                        showNotification(`Der Report wurde erfolgreich gelöscht.`),
                        deleteReportSuccess(action.payload.id),
                    ]);
                }),
                catchError( error => {
                    return from([
                        deleteReportFailure(error),
                    ])
                })
            )
        ),
    );
}
